import { render, staticRenderFns } from "./AddStudentModal.vue?vue&type=template&id=3bd0b938&scoped=true&"
import script from "./AddStudentModal.vue?vue&type=script&lang=js&"
export * from "./AddStudentModal.vue?vue&type=script&lang=js&"
import style0 from "./AddStudentModal.vue?vue&type=style&index=0&id=3bd0b938&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd0b938",
  null
  
)

export default component.exports